import { createStorageManager } from "app/pages/sales-intelligence/services/storage-manager/factory";

const sessionStorageManager = createStorageManager(window.sessionStorage, (key) => `si:company-analysis:${key}`);

export const companyAnalysisSessionStorage = sessionStorageManager.configList({
    conversionRateUpgradeHookSubmitted: { key: "conversion-rate-upgrade-hook-submitted", defaultValue: false },
});
